import React from "react";
import "./PanelCard.scss";

/**
 * Generic premium surface used by every dashboard section.
 * Keeps section headers, tools and body padding consistent across the page.
 */
const PanelCard = ({
  title,
  subtitle,
  icon = null,
  actions = null,
  accent = "brand",
  padded = true,
  className = "",
  bodyClassName = "",
  children,
}) => {
  return (
    <section className={`dsh-panel dsh-panel--${accent} ${className}`}>
      {(title || actions) && (
        <header className="dsh-panel__head">
          <div className="dsh-panel__heading">
            {icon && <span className="dsh-panel__icon">{icon}</span>}
            <div className="dsh-panel__titles">
              <h3>{title}</h3>
              {subtitle && <p>{subtitle}</p>}
            </div>
          </div>
          {actions && <div className="dsh-panel__actions">{actions}</div>}
        </header>
      )}
      <div
        className={`dsh-panel__body ${padded ? "" : "is-flush"} ${bodyClassName}`}
      >
        {children}
      </div>
    </section>
  );
};

export default PanelCard;
